import React from "react";
import { makeStyles } from "tss-react/mui";

import Container from "@mui/material/Container";

import CommonLayout from "../../Common/Layout";
import HelpContextIcon from "../../Common/HelpPanel/HelpContextIcon";

import DetailTable from "./DetailTable";

const useStyles = makeStyles()((theme) => ({
  PanelContainer: {
    padding: "10px 30px 30px 30px",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
}));

const breadcrumbArr = [
  { link: "/reports", displayName: "Reports", active: false },
  { link: "#", displayName: "Worksapce Access", active: true },
];

const DataAIUsage = () => {
  const { classes } = useStyles();

  return (
    <CommonLayout
      title={
        <>
          Worksapce Access
          <HelpContextIcon screen="Worksapce Access" />
        </>
      }
      breadcrumbArr={breadcrumbArr}
    >
      <Container maxWidth="false" sx={{ m: 0 }} className={classes.PanelContainer}>
        <DetailTable />
      </Container>
    </CommonLayout>
  );
};

export default DataAIUsage;
